import { NavLink } from "react-router-dom";
import Logo from "../atoms/Logo";
import {
  Alarm,
  Calendar,
  Category,
  Lifebuoy,
  MessageText,
  Moneys,
  Profile2User,
  Setting2,
  User,
} from "iconsax-react";
import UserMenu from "./UserMenu";

export default function Sidebar() {
  const navItems = [
    { to: "/dashboard", label: "Dashboard", icon: Category },
    { to: "/user", label: "User Management", icon: User },
    { to: "/groups", label: "Group Management", icon: Profile2User },
    { to: "/moderation", label: "Moderation", icon: Alarm },
    { to: "/finance", label: "Finance", icon: Moneys },
    { to: "/messages", label: "Messages", icon: MessageText },
    { to: "/events", label: "Events", icon: Calendar },
    { to: "/settings", label: "Settings", icon: Setting2 },
    { to: "/support", label: "Support", icon: Lifebuoy },
    
  ];

  return (
    <aside className="w-[248px] h-full border-r border-dark-10 px-3 py-2">
      <div className="py-5">
        <Logo variant="light" />
      </div>

      <nav className="my-5 space-y-2">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to} 
            className={({ isActive }) =>
              `flex items-center gap-2 p-2 rounded-[5px] hover:bg-dark-20 ${
                isActive
                  ? "bg-dark-20 font-medium text-white"
                  : "text-[#606060]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  variant="Bold"
                  size={20}
                  color={isActive ? "#FEFEFE" : "#606060"}
                />
                <p className="text-sm">{label}</p>
              </>
            )}
          </NavLink>
        ))}
        <button>
          
        </button>
      </nav>

      <div className="">
        <UserMenu />
      </div>
    </aside>
  );
}
